// Copyright 2026. WebPros International GmbH. All rights reserved.

import { Icon } from '@plesk/ui-library';
import styled from 'styled-components';

import { ReactComponent as RoundedSlash } from 'common/icons/rounded-slash.svg';
import { COLORS } from 'common/theme';

export const Container = styled.div`
    display: flex;
    align-items: center;
`;

export const RunningContainer = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const Row = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const TextWrapper = styled.div`
    margin-left: 8px;
`;

export const Title = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
`;

export const Progress = styled.div`
    margin-top: 2px;
    font-size: 12px;
    line-height: 16px;
    color: ${COLORS.GREY_80};
`;

export const ButtonWrapper = styled.div`
    margin-left: 4px;
`;

export const WaitingIconWrapper = styled.div`
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background: ${COLORS.INFO};
    color: ${COLORS.WHITE_0};
`;

export const CanceledIcon = styled(RoundedSlash)`
    width: 16px;
    height: 16px;
    color: ${COLORS.GREY_70};
`;

export const DoneWithErrorsIcon = styled(Icon)`
    color: ${COLORS.WARNING};
`;

export const FailedIcon = styled(Icon)`
    color: ${COLORS.DANGER};
`;

export const SuccessIcon = styled(Icon)`
    color: ${COLORS.SUCCESS};
`;
